import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	data: [],
	loading: false,
};

const getParametersStart = (state) => {
	return updateObject(state, { loading: true });
};

const getParametersSuccess = (state, action) => {
	return updateObject(state, { data: action.data, loading: false });
};

const states = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_ENGINEERINGPARAMS_START:
			return getParametersStart(state, action);
		case actionTypes.GET_ENGINEERINGPARAMS_SUCCESS:
			return getParametersSuccess(state, action);
		default:
			return state;
	}
};

export default states;
